import { render, staticRenderFns } from "./projectComponentCard.vue?vue&type=template&id=7b021449"
import script from "./projectComponentCard.vue?vue&type=script&lang=js"
export * from "./projectComponentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports